module.exports = __webpack_public_path__ + "img/store-label.fd1078ce.png";